import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Activite from './views/Activite.vue'
import Fureteurs from './views/Fureteurs.vue'
import Aujourdhui from './views/Aujourdhui.vue'
import SoumissionRliss from './views/SoumissionRliss.vue'
import Plans from './views/Plans.vue'
import OnComparaison from './views/OnComparaison.vue'
import OnAcces from './views/OnAcces.vue'
import OnHebdo from './views/OnHebdo.vue'
import OnFss from './views/OnFss.vue'
import OnTdb from './views/OnTdb.vue'
import OnPlansEnSouffrance from './views/OnPlansEnSouffrance.vue'
import OnSecteursSousRegions from './views/OnSecteursSousRegions.vue'

import ManStatut from './views/ManStatut.vue'
import RatiosEmplois from './views/RatiosEmplois.vue'
import RatiosEmploisAgency from './views/RatiosEmploisAgency.vue'
import RatiosEmploisSite from './views/RatiosEmploisSite.vue'

import OnValidation from './views/OnValidation.vue'
import OnValidationFss from './views/OnValidationFss.vue'

import OnRH from './views/OnRH.vue'
import OnRHFss from './views/OnRHFss.vue'

import TheTopBar from './components/TheTopBar.vue';
import TheSideNav from './components/TheSideNav.vue';

Vue.use(Router)

export default new Router({
  base: "/",
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/login',
      components: {fullScreen: Login}
    },
    {
      path: '/tableaudebord',
      components: {
        default: OnTdb,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/activite',
      components: {
        default: Activite,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/fureteurs',
      components: {
        default: Fureteurs,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/jour',
      components: {
        default: Aujourdhui,
        topBar: TheTopBar,
        sideNav: TheSideNav
      },
      alias: ''
    },
    {
      path: '/soumissions',
      components: {
        default: SoumissionRliss,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/plans',
      components: {
        default: Plans,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/on/hebdo',
      components: {
        default: OnHebdo,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/on/souffrance',
      components: {
        default: OnPlansEnSouffrance,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/on/comparaison',
      components: {
        default: OnComparaison,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/on/acces',
      components: {
        default: OnAcces,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/on/secteurssousregions',
      components: {
        default: OnSecteursSousRegions,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/on/comparaison/:agency_id',
      components: {
        default: OnFss,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/on/validation',
      components: {
        default: OnValidation,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/on/validation/:agency_id',
      components: {
        default: OnValidationFss,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/on/rh',
      components: {
        default: OnRH,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },    {
      path: '/on/rh/:agency_id',
      components: {
        default: OnRHFss,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/man/statut',
      components: {
        default: ManStatut,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/on/ratiosemplois',
      components: {
        default: RatiosEmplois,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/on/ratiosemplois/:agency_id',
      components: {
        default: RatiosEmploisAgency,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/on/ratiosemplois/:agency_id/:point_services_id/:period',
      components: {
        default: RatiosEmploisSite,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    }
  ]
})
